import { load } from '@/router/routes/index';

export default [
    {
        path: 'evaluators',
        component: load('evaluator/EvaluatorIndex'),
        meta: { auth: true },
        children: [
            {
                path: '',
                name: 'evaluator.index',
                component: load("evaluator/EvaluatorIndexPackage"),
                meta: { auth: true },
            },
            {
                path: 'goals',
                name: 'goal.index',
                component: load("evaluator/EvaluatorIndexGoal"),
                meta: { auth: true },
            },
        ]
    },
    {
        path: 'evaluators/goals/create',
        name: 'goal.create',
        component: load('evaluator/GoalCreate'),
        meta: { auth: true },
            
    },
    {
        path: 'evaluators/goals/:goalId',
        component: load('evaluator/GoalDetail'),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('evaluator/GoalShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'goal.show',
                        component: load('evaluator/GoalShowOverview'),
                        meta: { auth: true },
                    },
                ],
            },
            {
                path: 'edit',
                name: 'goal.edit',
                component: load('evaluator/GoalEdit'),
                meta: { auth: true },
            },
        ],
    },
    {
        path: 'evaluators/packages/create',
        name: 'package.create',
        component: load("evaluator/PackageCreate"),
        meta: { auth: true },
    },
    {
        path: 'evaluators/packages/:packageId',
        component: load("evaluator/PackageDetail"),
        meta: { auth: true },
        children: [
            {
                path: '',
                component: load('evaluator/PackageShow'),
                meta: { auth: true },
                children: [
                    {
                        path: '',
                        name: 'package.show',
                        component: load('evaluator/PackageShowGoals'),
                        meta: { auth: true },
                    },
                    {
                        path:'goals',
                        name: 'package.show.attachments',
                        component: load('evaluator/PackageShowAttachments'),
                        meta: { auth: true },
                    },
                ],
            },
            // {
            //     path: 'goals/:packageGoalId',
            //     component: load("evaluator/PackageGoalDetail"),
            //     meta: { auth: true },
            //     children: [
            //         {
            //             path: '',
            //             component: load('evaluator/PackageGoalShow'),
            //             meta: { auth: true },
            //             children: [
            //                 {
            //                     path: '',
            //                     name: 'package-goal.show',
            //                     component: load('evaluator/PackageGoalShowOverview'),
            //                     meta: { auth: true },
            //                 },
            //             ],
            //         },
            //     ],
            // },
            {
                path: 'edit',
                name: 'package.edit',
                component: load('evaluator/PackageEdit'),
                meta: { auth: true },
            },
        ]
    }
];
